import { graphql } from 'gatsby';
import React from 'react';
import { stripTags, stripTagsForID } from 'utils/striptags.utils';
import classNames from 'classnames';

import './heading.scss';

interface Props {
  content: string;
  numbering?: string;
  level: string;
  anchor?: string;
  className: string;
  textAlign: string;
}

export const query = graphql`
  fragment HeadingBlock on WpCoreHeadingBlock {
    attributes {
      ... on WpCoreHeadingBlockAttributes {
        content
        level
        anchor
        className
        textAlign
      }
    }
  }
`;

const Heading: React.FC<Props> = (props) => {
  const tagName = `h${props.level}`;
  const Tag = tagName as keyof JSX.IntrinsicElements;

  let content = props.content;
  if (!!props.numbering) {
    content = `${props.numbering} ${props.content}`;
  }

  const textAlign = props.textAlign ? 'align-' + props.textAlign : '';

  return (
    <>
      {!!props.anchor && (
        <div className="heading-anchor-container">
          <div className="heading-anchor" id={props.anchor}></div>
        </div>
      )}
      <Tag className={classNames(props.className, textAlign)} dangerouslySetInnerHTML={{ __html: content }} id={stripTagsForID(content)} />
    </>
  );
};

export default Heading;
